import {Card} from "react-bootstrap";
import {useCurrentUser} from "_api/hooks/auth";
import {UserDefaultAvatar} from "_const";
import {Button, Buttons} from "_ui/Button";
import {useRef, useState} from "react";
import {useUploadPhoto} from "_api/hooks/profile";
import {toastRun} from "_utils/misc";
import {toastSuccess} from "_components/ToastProvider";
import {Avatar} from "_ui/Avatar";

export const ProfilePictureCard = () => {
    const {user} = useCurrentUser();
    const {mutateAsync: upload, isPending: loading} = useUploadPhoto();

    const fileInput = useRef<HTMLInputElement>(null);

    const handleChange = async (e) => {
        const selectedFile = e.target.files[0];

        const formData = new FormData();
        formData.append('file', selectedFile);

        await toastRun(upload(formData),
            () => toastSuccess('Foto de perfil atualizada.')
        );
    }

    return (
        <Card>
            <Card.Body>
                <div className="d-flex flex-column align-items-center text-center">
                    <Avatar url={user.avatar}/>

                    {/*<img src={user.avatar*/}
                    {/*    ? user.avatar*/}
                    {/*    : UserDefaultAvatar} alt="user" className="rounded-circle"/>*/}

                    <div className="mt-2 d-flex flex-column align-items-center">
                        <h4>{user.name}</h4>
                        <p>{user.roleName}</p>
                        {/*<p className="text-secondary mb-1">{user.role}</p>*/}
                        <p className="text-muted font-14">{user.email}</p>
                        <Buttons>
                            <input className='d-none' type="file" onChange={handleChange} multiple={false}
                                   ref={fileInput} accept="image/png, image/jpeg, image/gif, image/webp"/>
                            <Button icon='fa-upload' text="Enviar foto"
                                    onClick={() => fileInput?.current?.click()} {...{loading}}/>
                        </Buttons>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
}

